export default "__VITE_PUBLIC_ASSET__3b504727__"